// 中文路由

import Layout from "@views/layout";
import Other from "@views/layout/other";

const zhRouter = [
    {
        path: "/",
        name: "DASHBOARD",
        component: Layout,
        redirect: { name: 'DASHBOARD_LIST' },
        children: [
            {
                path: "/en/index/index",
                name: "DASHBOARD_LIST",
                meta: {
                    title: "Home-OceanClub technical community", personname: "DASHBOARD_LIST"
                },
                component: () => import('@views/home/index'),
            }
        ]
    },
    // 活动 active
    {
        path: "/",
        name: "ACTIVE",
        component: Layout,
        redirect: { name: 'ACTIVE_LIST' },
        children: [
            {
                path: "/en/activity/index",
                name: "ACTIVE_LIST",
                meta: { title: "Events-OceanClub technical community", personname: 'ACTIVE_LIST' },
                component: () => import('@views/active/index'),
            }
        ]
    },
    // 赞助
    {
        path: "/",
        name: "STATIONED",
        component: Layout,
        redirect: { name: 'STATIONED_LIST' },
        children: [
            {
                path: "/en/stationed/index",
                name: "STATIONED_LIST",
                meta: { title: "Experts-OceanClub technical community", personname: 'STATIONED_LIST' },
                component: () => import('@views/stationed/index'),
            },
            {
                path: "/en/stationed/info/:id/:tab/:type",
                name: "STATIONED_INFO",
                meta: { title: "Experts-OceanClub technical community", personname: 'STATIONED_LIST' },
                component: () => import('@views/stationed/info'),
            },
            {
                path: "/en/stationed/application",
                name: "STATIONED_APPLICATION",
                meta: { title: "Experts-OceanClub technical community", personname: 'STATIONED_LIST', hideFooter: true },
                component: () => import('@views/stationed/application'),
            },
            {
                path: "/en/stationed/mvp",
                name: "STATIONED_APPLICATION",
                meta: { title: "Experts-OceanClub technical community", personname: 'STATIONED_LIST', hideFooter: true },
                component: () => import('@views/mvp/index'),
            },
        ]
    },
    // 活动详情 active
    {
        path: "/",
        name: "ACTIVEINFO",
        component: Layout,
        redirect: { name: 'ACTIVEINFO_LIST' },
        children: [
            {
                path: "/en/activity/info/:id",
                name: "ACTIVE_LIST",
                meta: { title: "Events-OceanClub technical community", personname: 'ACTIVE_LIST' },
                component: () => import('@views/activeInfo/index'),
            }
        ]
    },
    // 积分 points
    {
      path: "/",
      name: "POINTS",
      component: Layout,
      redirect: { name: "POINTS" },
      children: [
        {
          path: "/en/points/ranking/:ta_id",
          name: "POINTS_RANKING",
          meta: { title: "Activity - Points Ranking List - OceanClub technical community", personname: "POINTS_RANKING" },
          component: () => import("@views/points/ranking"),
        },
        {
          path: "/en/points/detail/:ta_id",
          name: "POINTS_DETAIL",
          meta: { title: "Activity - Points Details - OceanClub technical community", personname: "POINTS_DETAIL" },
          component: () => import("@views/points/detail"),
        },
      ],
    },
    // 挑战赛 challenge
    {
    path: "/",
    name: "CHALLENGE",
    component: Layout,
    redirect: { name: "CHALLENGE" },
    children: [
        {
            path: "/en/challenge/info/:id",
            name: "CHALLENGE_LIST",
            meta: { title: "Activity - OceanClub Tech Community", personname: "ACTIVE_LIST" },
            component: () => import("@views/challenge/index"),
        },
        {
        path: "/en/challenge/daily/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_DAILY",
        meta: { title: "Activity - Daily Question - OceanClub Tech Community", personname: "CHALLENGE_DAILY" },
        component: () => import("@views/challenge/daily"),
        },
        {
        path: "/en/challenge/weekly/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_WEEKLY",
        meta: { title: "Activity - Weekly Question - OceanClub Tech Community", personname: "CHALLENGE_WEEKLY" },
        component: () => import("@views/challenge/weekly"),
        },
        {
        path: "/en/challenge/lecture/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_LECTURE",
        meta: { title: "Activity - Apply for the Lecture Hall - OceanClub Tech Community", personname: "CHALLENGE_LECTURE" },
        component: () => import("@views/challenge/lecture"),
        },
        {
        path: "/en/challenge/circlepart/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_CIRCLEPART",
        meta: { title: "Activity - Proof of the Event Participation - OceanClub Tech Community", personname: "CHALLENGE_CIRCLEPART" },
        component: () => import("@views/challenge/circlepart"),
        },
        {
        path: "/en/challenge/circlelecture/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_CIRCLELECTURE" ,
        meta: { title: "Activity - Proof of the Event Speech  - OceanClub Tech Community", personname: "CHALLENGE_CIRCLELECTURE" },
        component: () => import("@views/challenge/circlelecture"),
        },
        {
        path: "/en/challenge/technicalarticles/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_TECHNICALARTICLES",
        meta: { title: "Activity - Write a technical article - OceanClub Tech Community", personname: "CHALLENGE_TECHNICALARTICLES" },
        component: () => import("@views/challenge/technicalarticles"),
        },
        {
        path: "/en/challenge/projectorder/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_PROJECTORDER",
        meta: { title: "Activity - Proof of Project Order - OceanClub Tech Community", personname: "CHALLENGE_PROJECTORDER" },
        component: () => import("@views/challenge/projectorder"),
        }, 
        {
        path: "/en/challenge/certificate/:ta_id/:tas_id/:tasp_id",
        name: "CHALLENGE_CERTIFICATE",
        meta: { title: "Activity - HCSX/HCIX Certificate - OceanClub Tech Community", personname: "CHALLENGE_CERTIFICATE" },
        component: () => import("@views/challenge/certificate"),
        },

    ],
    },
    /* 问卷 */
    {
        path: "/en/questionnaire/:ta_id",
        name: "QUESTIONNAIRE",
        meta: { title: "Questionnaire-OceanClub technical community", personname: "QUESTIONNAIRE" },
        component: () => import("@views/questionnaire/index"),
    },
    // 话题
    {
        path: "/",
        name: "SUBJECT",
        component: Layout,
        redirect: { name: 'SUBJECT_LIST' },
        children: [
            {
                path: "/en/subject/list",
                name: "SUBJECT_LIST",
                meta: { title: "Topics-OceanClub technical community", personname: 'SUBJECT_LIST' },
                component: () => import('@views/subject/index'),
            },
            {
                path: "/en/subject/info/:id",
                name: "SUBJECT_INFO",
                meta: { title: "Topics-OceanClub technical community", personname: 'SUBJECT_LIST' },
                component: () => import('@views/subject/info'),
            },
            {
                // 主持人专区
                path: "/en/subject/hostZone",
                name: "SUBJECT_HOSTZONE",
                meta: { title: "Topics-OceanClub technical community", personname: 'SUBJECT_LIST' },
                component: () => import('@views/subject/hostZone'),
            },
            {
                // 相关活动列表
                path: "/en/subject/activeList/:id",
                name: "SUBJECT_ACTIVELIST",
                meta: { title: "Topics-OceanClub technical community", personname: 'SUBJECT_LIST' },
                component: () => import('@views/subject/activeList'),
            },
        ]
    },
    // 讨论
    {
        path: "/",
        name: "DISCUSS",
        component: Layout,
        redirect: { name: 'DISCUSS_LIST' },
        children: [
            {
                path: "/en/discuss/list",
                name: "DISCUSS_LIST",
                meta: { title: "Discussions-OceanClub technical community", personname: 'DISCUSS_LIST' },
                component: () => import('@views/discuss/index'),
            },
            {
                path: "/en/discuss/moderatorzone",
                name: "DISCUSS_MODERATORZONE",
                meta: { title: "Discussions-OceanClub technical community", personname: 'DISCUSS_LIST' },
                component: () => import('@views/discuss/moderatorZone'),
            }, {
                path: "/en/discuss/info/:id/:is_preview?",
                name: "DISCUSS_INFO",
                meta: { title: "Discussions-OceanClub technical community", personname: 'DISCUSS_LIST' },
                component: () => import('@views/discuss/info'),
            },

        ]
    },
    {
        // 签到报名
        path: "/",
        name: "SIGNREGIST",
        component: Other,
        redirect: { name: 'SIGNREGIST_LIST' },
        children: [
            {
                path: "/en/signregist/list/:ta_id/:sign_type/:view_type",
                name: "SIGNREGIST_LIST",
                meta: { title: "Register to Sign Up", personname: 'SIGNREGIST_LIST' },
                component: () => import('@views/signregist/index'),
            },
        ]
    },
  // 登录
  {
    path: "/en/login/:logintype?/:loginTab?",
    name: "LOGIN",
    meta: { title: "Login - OceanClub Technology Community", personname: "LOGIN" },
    component: () => import('@views/login/index'),
  },
  // 个人信息完善
  {
    path: "/en/information",
    name: "INFORMATION",
    meta: { title: "Personal Information Completion - OceanClub Technology Community", personname: "INFORMATION" },
    component: () => import('@views/login/information'),
  },
  // 找回密码
  {
    path: "/en/forget",
    name: "FORGET",
    meta: { title: "Password Recovery - OceanClub Technology Community", personname: "FORGET" },
    component: () => import('@views/login/forget'),
  },
  // 全局搜索
  {
    path: "/",
    name: "SEARCH",
    component: Layout,
    redirect: { name: 'SEARCH_LIST' },
    children: [
      {
        path: "/en/search/:search_key?",
        name: "SEARCH_LIST",
        meta: { title: "search-OceanClub Technology Community", personname: "SEARCH" },
        component: () => import("@views/search/index"),
        }
    ]
  },
  {
    path: "/",
    name: "USER",
    component: Layout,
    redirect: { name: 'USER_LIST' },
    children: [
      {
        path: "/en/userinfo",
        name: "USERCENTER",
        meta: { title: "Personal Center-OceanClub Technology Community", personname: "USER" },
        component: () => import("@views/user/index"),
        }
    ]
},
 // 期刊
  {
    path: "/",
    name: "JOURNAL",
    component: Layout,
    redirect: { name: 'JOURNAL_LIST' },
    children: [
      {
        path: "/en/journal/index",
        name: "JOURNAL_LIST",
        meta: { title: "Ebooks-OceanClub Technology Community", personname: "JOURNAL_LIST" },
        component: () => import("@views/journal/index"),
      },
      {
        path: "/en/journal/info/:id",
        name: "JOURNAL_LIST",
        meta: { title: "Ebooks-OceanClub Technology Community", personname: "JOURNAL_LIST" },
        component: () => import("@views/journal/info"),
      }
    ]
  },
  // 关于我们
    {
      path: "/",
      name: "ABOUT",
      component: Layout,
      redirect: { name: 'ABOUT_LIST' },
      children: [
        {
          path: "/en/about",
          name: "ABOUT_LIST",
          meta: { title: "About-OceanClub Technology Community", personname: "ABOUT_LIST" },
          component: () => import("@views/about/index.vue"),
        }
      ]
    },
  // 合作
  {
    path: "/",
    name: "COOPERATE",
    component: Layout,
    redirect: { name: 'COOPERATE_LIST' },
    children: [
      {
        path: "/en/cooperate/index",
        name: "COOPERATE_LIST",
        meta: { title: "Cooperation-OceanClub technical community", personname: "COOPERATE_LIST" },
        component: () => import("@views/cooperate/index"),
      },
      {
        path: "/en/cooperate/info/:id",
        name: "COOPERATE_INFO",
        meta: { title: "Cooperation-OceanClub technical community", personname: "COOPERATE_INFO" },
        component: () => import("@views/cooperate/info"),
      }
    ]
  }

]

export default zhRouter;